import { MIS_RISK_REGISTER } from '../resources/endPoint';
import { serviceName } from '../resources/serviceConstants';
import {
  appendServiceNameToURL,
  appendServicePortToURL,
} from '../resources/serviceURLs';

/**
 * Builds the base URL for the Risk Register API.
 * Used by TableUtility's generalSettings.baseURL.
 */
export const getRiskRegisterBaseURL = () => {
  const serviceURL = appendServiceNameToURL(serviceName.PROJECT_MS);
  const servicePort = appendServicePortToURL(serviceName.PROJECT_MS);
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (process.env.NODE_ENV === 'production') {
    return `${baseUrl}${serviceURL}/api${MIS_RISK_REGISTER}`;
  }

  return `${baseUrl}:${servicePort}${serviceURL}/api${MIS_RISK_REGISTER}`;
};

/**
 * Request definition for fetching Risk Register data (list/filter).
 */
export const fetchRiskRegisterData = (requestBody) => {
  return {
    url: MIS_RISK_REGISTER,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: requestBody,
    service: serviceName.PROJECT_MS,
  };
};

/**
 * Request definition for exporting Risk Register data.
 */
export const fetchRiskRegisterExport = (requestBody) => {
  return {
    url: `${MIS_RISK_REGISTER}/export`,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: requestBody,
    service: serviceName.PROJECT_MS,
  };
};
